import React from 'react'
import { Tooltip as AntTooltip } from 'antd'
import { TooltipProps as AntTooltipProps } from 'antd/lib/tooltip'
import clsx from 'clsx'

import s from './Tooltip.module.css'

export type TooltipProps = AntTooltipProps

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  destroyTooltipOnHide,
  placement,
  overlayClassName,
  title,
  trigger,
  overlayStyle,
  color = 'var(--color-gray-900)',
  visible,
  arrowPointAtCenter,
  ...rest
}) => {
  const controlledProps = {
    ...(visible !== undefined && { visible })
  }
  return (
    <AntTooltip
      destroyTooltipOnHide={destroyTooltipOnHide}
      placement={placement}
      color={color}
      overlayClassName={clsx(overlayClassName, s.tooltip)}
      title={title}
      overlayStyle={overlayStyle}
      trigger={trigger}
      arrowPointAtCenter={arrowPointAtCenter}
      {...controlledProps}
      {...rest}
    >
      {children}
    </AntTooltip>
  )
}
